// eslint-disable-next-line import/prefer-default-export
export const getModals = (state) => state.modals;
